import { Component, Event, EventEmitter, Host, h, Prop } from "@stencil/core";
import { SvgLabel } from "./svg-label";

let id: number = 0;

@Component({
    tag: "ux-cookie-layer-switch",
    styleUrl: "cookie-layer-switch.scss",
    shadow: false,
})
export class CookieLayerSwitch {
    private labelId = `ux-cookie-layer-switch-${++id}-label`;

    /** If set to true, the switch does not respond to user interaction */
    @Prop() disabled: boolean = false;
    /** The on/off state */
    @Prop({ mutable: true, reflect: true }) on: boolean = false;
    /** Used to reference the switch */
    @Prop() name: string = "";
    /** Label text for the switch control */
    @Prop() label: string = "";
    /** Description for the switch control */
    @Prop() desc: string = "";

    /** Fired when switching on/off state */
    @Event({
        eventName: "uxSwitch",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    didToggle: EventEmitter<boolean>;

    private toggle = (e: UIEvent): void => {
        e.preventDefault();
        if (this.disabled) return;
        const on = !this.on;
        const toggleEvent: CustomEvent = this.didToggle.emit(on);
        if (toggleEvent.defaultPrevented) {
            return;
        }
        this.on = on;
    };

    render() {
        const baseClass = "ux-cookie-layer-switch";
        const { disabled, on, label, labelId } = this;
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--on`]: on,
                    [`${baseClass}--off`]: !on,
                    [`${baseClass}--disabled`]: disabled,
                }}
            >
                <div class={`${baseClass}__inner`}>
                    <span
                        role="label"
                        class={`${baseClass}__label`}
                        id={labelId}
                    >
                        {label}
                    </span>
                    <button
                        class={`${baseClass}__button`}
                        onClick={this.toggle}
                        disabled={disabled}
                        aria-labelledby={labelId}
                    >
                        <SvgLabel baseClass={baseClass} />
                        <span class={`${baseClass}__handle`} />
                    </button>
                </div>
                {this.desc.length > 0 && (
                    <div class={`${baseClass}__desc`} innerHTML={this.desc} />
                )}
            </Host>
        );
    }
}
